<template>
  <div class="contact-form section grid-view">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button
              no="delete"
              :disabled="!isEdit"
              size="mini"
              type="danger"
              @click="remove"
            >{{ $t('common.btn.delete') }}</el-button>
            <br>
            <div v-show="form.customer||form.overseaAgent||form.designationAgent" style="margin-top: 10px">
              <span style="padding-right: 10px">{{ $t('Partners.WhetherToPushSOPStatus') }}</span>
              <el-radio-group v-model="form.ifOpenSop" no="ifOpenSop" :disabled="readonly">
                <el-radio no="push" :label="true" style="margin-right: 10px">{{ $t('Partners.Push') }}</el-radio>
                <el-radio no="noPushing" :label="false">{{ $t('Partners.NoPushing') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          v-if="finalColumnDefs.length===9"
          :key="1"
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="finalColumnDefs"
          :row-data="finalRowData"
        />
        <cargo-ag-grid
          v-else
          :key="2"
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="finalColumnDefs"
          :row-data="finalRowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      class="contact-form"
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 1px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Payment.contactPerson')" required="true">
            <el-input v-model="editDialog.form.contactPerson" no="contactPerson" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Role')">
            <el-input v-model="editDialog.form.role" no="role" />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultContact" no="defaultContact" @change="onDefaultChange">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('queryJob.route')">
            <cargo-advance-select
              v-if="regionList.length>0"
              no="airline"
              :select-type="selectTypeNames.basic_data_Region"
              :cache="false"
              filterable
              :callback-params="{key:'airline'}"
              callback-method-type="value"
              :default-value="editDialog.form.airline"
              :static-options="regionList"
              style="width:260px;"
              @parentCallBack="selectCargoItem"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="editDialog.form.telephone" no="telephone" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Addr')">
            <el-input v-model="editDialog.form.address" no="address" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Fax')">
            <el-input
              v-model="editDialog.fax1"
              no="fax1"
              style="width: 80px;"
              @change="editDialog.form.fax=editDialog.fax1+'-'+editDialog.fax1"
            />
            &nbsp;-&nbsp;
            <el-input
              v-model="editDialog.fax2"
              no="fax2"
              style="width: 167px;"
              @change="editDialog.form.fax=editDialog.fax1+'-'+editDialog.fax1"
            />
          </el-form-item>
          <!--          <el-form-item :label="$t('SeaExport.Email')" :required="emailMode">-->
          <el-form-item :label="$t('SeaExport.Email')">
            <el-input v-model="editDialog.form.email" no="email" @blur="editDialog.form.email= editDialog.form.email ? editDialog.form.email.trim() : ''" />
          </el-form-item>
          <el-form-item v-show="editDialog.form.useEmailGroup" :label="$t('Partners.CcGroup')">
            <el-select
              v-model="editDialog.form.ccGroup"
              no="ccGroup"
              filterable
              multiple
              clearable
              style="width:260px"
              @change="resetCcAddress"
            >
              <el-option
                v-for="(item,index) in emailGroupCcList"
                :key="index"
                :label="item.groupName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.CcAddress')">
            <el-input v-model="editDialog.form.ccAddress" no="ccAddress" type="textarea" :rows="3" @blur="editDialog.form.ccAddress= editDialog.form.ccAddress ? editDialog.form.ccAddress.trim() : ''" />
          </el-form-item>
          <el-form-item>
            <div style="display: flex;align-items: start;">
              <el-checkbox v-model="editDialog.form.ccAgentOverseaOp" no="ccAgentOverseaOp" style="margin-right: 10px;" @change="resetCcAddress">{{ $t('Partners.ccAgentOverseaOp') }}</el-checkbox>
              <el-checkbox v-model="editDialog.form.useEmailGroup" no="useEmailGroup">{{ $t('Partners.UseEmailGroup') }}</el-checkbox>
            </div>
          </el-form-item>
          <!--          <el-form-item :label="$t('SeaExport.Mobile')" :required="phoneMode">-->
          <el-form-item :label="$t('SeaExport.Mobile')">
            <el-input v-model="editDialog.form.mobile" no="mobile" />
          </el-form-item>
          <el-form-item v-if="showSop" :label="$t('Partners.pushNode')">
            <el-dropdown
              placement="bottom-start"
              trigger="click"
            >
              <span class="el-dropdown-link">
                <el-input no="pushNodeStr" :value="editDialog.pushNodeStr" style="width:260px" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <cargo-ag-grid
                  :show-side-bar="false"
                  :grid-options="pushNodeTree.gridOptions"
                  :row-data="pushNodeTree.rowData"
                  style="width:350px;height:300px;padding-left:2px"
                  @gridReady="params=>{pushNodeTree.gridApi=params.api}"
                />
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item v-if="showSop" :label="$t('Partners.pushMode')">
            <el-select v-model="editDialog.form.pushMode" no="pushMode" style="width:260px">
              <el-option :label="$t('Viewer.email')" :value="0" />
              <el-option :label="$t('Partners.shortMessage')" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
          <el-form-item label="QQ">
            <el-input v-model="editDialog.form.qqAccout" no="QQ" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_WechatAccount')">
            <el-input v-model="editDialog.form.wechatAccout" no="wechat" />
          </el-form-item>
          <el-form-item label="Skype">
            <el-input v-model="editDialog.form.skypeAccout" no="skype" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_RpaAccount')">
            <el-input v-model="editDialog.form.rpaAccount" no="rpaAccount" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_WechatGroupName')">
            <el-input v-model="editDialog.form.wechatGroupName" no="wechatGroupName" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 组件样式模板（用于嵌入ag-grid）-->
    <div v-show="false">
      <el-checkbox ref="checkboxTrue" no="checkboxTrue" :value="true" class="no-pointer" />
      <el-checkbox ref="checkboxFalse" no="checkboxFalse" :value="false" class="no-pointer" />
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { validEmail, isNumber } from '@/utils/validate'
import { getAllRegionList } from '@/api/basicData/region'
import { getTrackingSopTree } from '@/api/sysManage/baseConfig/businessManage'
import { getContactList } from '@/api/partner/contact'
import { Company } from '@/class/model/mdm/Company'
import StrUtils from '@/utils/StrUtils'
import { TabError } from '@/utils/class/TabError'
import { getMailGroupList } from '@/api/basicData/mailGroup'
import { getOverseaAgentUserList } from '@/api/partner/overseaAgentUser'
import { getCacheListByKey } from '@/utils/basicDataCache'

export default {
  name: 'ContactForm',
  components: { cargoAdvanceSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      regionList: [],
      regionMap: new Map(),
      selectTypeNames: TYPE_NAMES,
      form: {
        uuid: '',
        customer: false,
        ifOpenSop: false
      },
      filter: {
        companyUuid: '',
        pageNum: 1,
        pageSize: 1000000
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.contactPerson'),
          field: 'contactPerson',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Role'),
          field: 'role',
          width: 100
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultContact',
          colId: 'defaultContact',
          initialWidth: 110,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'el-checkbox',
            attrs: {
              isEditCBFunc: (params) => {
                return this.isEdit
              }
            },
            valueChanged: p => {
              this.changeDefaultHandler(p)
            }
          }
        }, {
          headerName: this.$t('queryJob.route'),
          field: 'airline',
          width: 100,
          cellRenderer: params => {
            return this.regionMap.get(params.value) || ''
          }
        }, {
          headerName: this.$t('SeaExport.Tel'),
          field: 'telephone',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Addr'),
          field: 'address',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Fax'),
          field: 'fax',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Email'),
          field: 'email',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Mobile'),
          field: 'mobile',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.CargoMsg_QQ'),
          colId: 'qqAccout',
          field: 'qqAccout',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Wechat'),
          colId: 'wechatAccout',
          field: 'wechatAccout',
          width: 150
        }, {
          headerName: 'Skype',
          colId: 'skypeAccout',
          field: 'skypeAccout',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RpaAccount'),
          colId: 'rpaAccount',
          field: 'rpaAccount',
          initialWidth: 140, minWidth: 140
        }, {
          headerName: this.$t('CargoMsg.Cargo_WechatGroupName'),
          colId: 'wechatGroupName',
          field: 'wechatGroupName',
          initialWidth: 160, minWidth: 160
        }
      ],
      rowData: [],
      deletedContactKeys: [],
      editDialog: {
        visible: false,
        title: '',
        initialForm: {
          uuid: '',
          contactPerson: '',
          role: '',
          defaultContact: false,
          airline: '',
          telephone: '',
          address: '',
          fax: '',
          email: '',
          mobile: '',
          pushNode: '',
          pushMode: 0,
          remarks: '',
          qqAccout: '',
          wechatAccout: '',
          skypeAccout: '',
          companyUuid: '',
          ccGroup: '',
          ccAddress: '',
          ccAgentOverseaOp: false,
          useEmailGroup: false,
          rpaAccount: '',
          wechatGroupName: ''
        },
        form: {},
        fax1: '',
        fax2: '',
        pushNodeStr: ''
      },
      pushNodeTree: {
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Partners.pushNode'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 4) {
                  const iconName = params.data.checked ? 'checkbox-checked' : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 4) {
                params.data.checked = !params.data.checked
                params.api.refreshCells({ force: true })
                this.onPushNodeChange()
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      pushNodeMap: new Map(),
      autoIncrementNum: new AutoIncrementNum(),
      emailGroupCcList: []
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    readonly() {
      return !this.action || this.action === 'look'
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    emailMode() {
      return this.editDialog.form.pushMode === 0
    },
    phoneMode() {
      return this.editDialog.form.pushMode === 1
    },
    finalColumnDefs() {
      const result = [...this.columnDefs]
      if (this.form.customer || this.form.overseaAgent || this.form.designationAgent) {
        result.push({
          headerName: this.$t('Partners.pushNode'),
          field: 'pushNode',
          width: 200,
          cellRenderer: params => {
            if (params.value) {
              return Array.from(params.value.split(','), p => this.pushNodeMap.get(p) || '')
                .reduce((a, b) => a + ',' + b)
            } else {
              return ''
            }
          },
          tooltipValueGetter: params => {
            if (params.value) {
              return Array.from(params.value.split(','), p => this.pushNodeMap.get(p) || '')
                .reduce((a, b) => a + ',' + b)
            } else {
              return ''
            }
          }
        })
        result.push({
          headerName: this.$t('Partners.pushMode'),
          field: 'pushMode',
          width: 110,
          cellRenderer: params => {
            return params.value === 1 ? this.$t('Partners.shortMessage') : this.$t('Viewer.email')
          }
        })
      }
      result.push({
        headerName: this.$t('Payment.remarks'),
        field: 'remarks',
        width: 200
      })
      return result
    },
    finalRowData() {
      return this.rowData.filter(p => p.todo !== 'remove')
    },
    showSop() {
      return this.form && (this.form.customer || this.form.overseaAgent || this.form.designationAgent)
    }
  },
  created() {
    getAllRegionList().then(res => {
      this.regionList = res.data
      for (const item of res.data) {
        this.regionMap.set(item.code, item.name)
      }
    })
    getTrackingSopTree().then(res => {
      res.data.forEach(item => {
        item.checked = false
      })
      this.pushNodeTree.rowData = res.data
      for (const item of this.pushNodeTree.rowData) {
        if (item.type === 4) {
          this.pushNodeMap.set(item.uuid, item.chineseName)
        }
      }
    })
    getMailGroupList({ groupScene: 1, checkAll: true }).then(res => {
      this.emailGroupCcList = res.data.list
    })
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.form = row
        this.rowData = row.contacts
        for (const item of this.rowData) {
          item.seq = this.autoIncrementNum.getNextNum()
        }
        this.deletedContactKeys = []
      }
    },
    showEditDialog(isNew) {
      this.pushNodeTree.rowData = [...this.pushNodeTree.rowData]
      this.pushNodeTree.rowData.forEach(item => {
        item.checked = false
      })
      this.editDialog.pushNodeStr = ''
      if (isNew) {
        this.editDialog.form = {
          seq: this.autoIncrementNum.getNextNum(),
          ...this.editDialog.initialForm,
          todo: 'new'
        }
        this.editDialog.form.address = this.form.address
        this.editDialog.fax1 = ''
        this.editDialog.fax2 = ''
        this.editDialog.form.companyUuid = this.form.companyUuid
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        const cell = this.gridApi.getFocusedCell()
        const row = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        const faxes = this.editDialog.form.fax.split('-')
        this.editDialog.fax1 = faxes[0] || ''
        this.editDialog.fax2 = faxes[1] || ''
        this.editDialog.form.todo = this.editDialog.form.todo || 'edit'
        this.editDialog.title = this.$t('common.btn.edit')
        if (this.editDialog.form.pushNode) {
          const nodeUuidArr = this.editDialog.form.pushNode.split(',')
          this.pushNodeTree.rowData.forEach(item => {
            if (nodeUuidArr.includes(item.uuid)) {
              item.checked = true
            }
          })
          this.onPushNodeChange()
        }
      }
      if (this.pushNodeTree.gridApi) {
        this.pushNodeTree.gridApi.refreshCells({ force: true })
      }
      this.editDialog.visible = true
    },
    onDefaultChange() {
      const form = this.editDialog.form
      if (form.defaultContact) {
        const existItem = this.finalRowData.find(p => p.defaultContact && p.seq !== form.seq)
        if (existItem) {
          this.$message.warning(this.$t('Partners.alreadyDefaultContact'))
        }
      }
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    onPushNodeChange() {
      const rows = this.pushNodeTree.rowData.filter(p => p.checked)
      if (rows.length > 0) {
        this.editDialog.form.pushNode = Array.from(rows, p => p.uuid)
          .reduce((a, b) => a + ',' + b)
        this.editDialog.pushNodeStr = Array.from(rows, p => p.chineseName)
          .reduce((a, b) => a + ',' + b)
      } else {
        this.editDialog.form.pushNode = ''
        this.editDialog.pushNodeStr = ''
      }
    },
    // 暂存
    async saveSub() {
      const form = this.editDialog.form
      // 基本格式校验
      const msg = this.getFieldsCheckResult()
      if (msg) {
        this.$message.warning(msg)
        return
      }
      // if (form.email && !validEmail(form.email)) {
      //   this.$message.warning(this.$t('Partners.emailFormatError'))
      //   return
      // }
      // if (StrUtils.isEmpty(form.contactPerson) || (StrUtils.isEmpty(form.telephone) && StrUtils.isEmpty(form.mobile))) {
      //   this.$message.warning(this.$t('Partners.contactNameAndPhoneNumberCannotBlank'))
      //   return false
      // }
      // if (form.mobile && !isNumber(form.mobile)) {
      //   this.$message.warning(this.$t('Partners.mobilePhoneNumberValidNumber'))
      //   return
      // }
      // 判断是否要设置为默认联系人
      if (form.defaultContact) {
        const existItem = this.finalRowData.find(p => p.defaultContact && p.seq !== form.seq)
        if (existItem) {
          existItem.defaultContact = false
          existItem.todo = existItem.todo || 'edit'
        }
      } else {
        const existItem = this.finalRowData.find(p => !!p.defaultContact)
        if (!existItem) {
          form.defaultContact = true
        }
      }
      // 校验数据格式
      try {
        await this.checkModel(form)
      } catch (err) {
        if (err instanceof TabError) {
          if (err.message) {
            this.$message.warning(err.message)
          }
        }
        return
      }
      // 数据暂存
      const row = this.rowData.find(item => item.seq === form.seq)
      if (row) {
        Object.assign(row, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      this.editDialog.visible = false
    },
    getFieldsCheckResult() {
      const form = this.editDialog.form
      // 基本格式校验
      if (StrUtils.isEmpty(form.contactPerson)) {
        return this.$t('Partners.contactNameCannotBlank')
      }
      // if (this.emailMode && (StrUtils.isEmpty(form.email) || !validEmail(form.email))) {
      //   return this.$t('Partners.emailBlankOrFormatError')
      // }
      // if (this.phoneMode && (StrUtils.isEmpty(form.mobile) || !isNumber(form.mobile))) {
      //   return this.$t('Partners.mobileBlankOrFormatError')
      // }
      // 相同航线联系人信息校验
      let sameAirline
      for (const contact of this.finalRowData) {
        let ifSame = false
        ifSame = contact.contactPerson === form.contactPerson
        ifSame = ifSame && (contact.pushMode === form.pushMode)
        ifSame = ifSame && (contact.airline === form.airline)
        ifSame = ifSame && (contact.seq !== form.seq)
        if (form.email) {
          ifSame = ifSame && (contact.email === form.email)
        }
        if (form.mobile) {
          ifSame = ifSame && (contact.mobile === form.mobile)
        }
        if (ifSame) {
          sameAirline = contact
          break
        }
      }
      if (sameAirline) {
        const modeStr = this.emailMode ? this.$t('Partners.mailMode') : this.$t('Partners.phoneMode')
        if (sameAirline.email && (sameAirline.email === form.email)) {
          return this.$t('Partners.sameAirlineInvalidMsg', [form.contactPerson, modeStr, this.$t('SeaExport.Email')])
        }
        if (sameAirline.mobile && (sameAirline.mobile === form.mobile)) {
          return this.$t('Partners.sameAirlineInvalidMsg', [form.contactPerson, modeStr, this.$t('Message.CellPhoneNumber2')])
        }
      }
      return ''
    },
    remove() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        if (index >= 0) {
          this.rowData.splice(index, 1)
          if (row.uuid) {
            this.deletedContactKeys.push(row.uuid)
          }
        }
      }).catch(() => { })
    },
    getSubmitData() {
      this.checkModel()
      return {
        company: this.form,
        contacts: this.rowData,
        deletedContactKeys: this.deletedContactKeys
      }
    },
    checkModel(row) {
      // 有入参时校验入参联系人，无入参时校验整个联系人列表
      const rows = row ? [row] : this.finalRowData
      if (this.form.customer) {
        if (rows == null || rows === 0) {
          throw new TabError(this.$t('CargoMsg.Cargo_ContactPersonToFillInA'), 'contactForm')
        }
      }
      for (const contact of rows) {
        // if (StrUtils.isEmpty(contact.contactPerson) || (StrUtils.isEmpty(contact.telephone) && StrUtils.isEmpty(contact.mobile))) {
        //   throw new TabError(this.$t('Partners.contactNameAndPhoneNumberCannotBlank'), 'contactForm')
        // }
        const mailRegex = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
        if (!StrUtils.isEmpty(contact.email) && contact.email.indexOf('@') === -1 && !contact.email.match(mailRegex)) {
          throw new TabError(this.$t('Information.EmailFormatError'), 'contactForm')
        }
        if (!StrUtils.isEmpty(contact.email) && contact.email.length > 128) {
          throw new TabError(this.$t('Partners.emailLengthCannotExceed128Characters'), 'contactForm')
        }
        const regex = /^[0-9]*$/
        if (!StrUtils.isEmpty(contact.mobile) && !regex.test(contact.mobile)) {
          throw new TabError(this.$t('Partners.mobilePhoneNumberValidNumber'), 'contactForm')
        }
        if (!StrUtils.isEmpty(contact.mobile) && contact.mobile.length > 32) {
          throw new TabError(this.$t('Partners.phoneNumberLengthCannotExceed32Characters'), 'contactForm')
        }
        if (!StrUtils.isEmpty(contact.telephone) && contact.telephone.length > 32) {
          throw new TabError(this.$t('Partners.phoneNumberCannotLongerThan32Characters'), 'contactForm')
        }
      }
      return true
    },
    changeDefaultHandler(p) {
      const data = p.data
      if (data.defaultContact) {
        const existItem = this.finalRowData.find(p => p.defaultContact && p.seq !== data.seq)
        if (existItem) {
          existItem.defaultContact = false
          existItem.todo = existItem.todo || 'edit'
        }
      } else {
        const existItem = this.finalRowData.find(p => !!p.defaultContact)
        if (!existItem) {
          data.defaultContact = true
        }
      }
    },
    // 重置抄送地址
    async resetCcAddress() {
      const items = this.editDialog.form.ccGroup
      const emails = []
      for (const option of this.emailGroupCcList) {
        if (items.includes(option.uuid) && option.emailAddress) {
          const items = option.emailAddress.split('\n')
          for (const item of items) {
            let newItem = item.trim().replaceAll(';', ',')
            if (newItem.endsWith(',')) {
              newItem = newItem.substring(0, newItem.length - 1)
            }
            if (!emails.includes(newItem)) {
              emails.push(newItem)
            }
          }
        }
      }
      if (this.editDialog.form.ccAgentOverseaOp) {
        const overseaAgentDetail = this.form.overseaAgentDetail
        if (overseaAgentDetail.uuid) {
          await getOverseaAgentUserList({ overseaAgentUuid: overseaAgentDetail.uuid }).then(res => {
            if (res.data.list && res.data.list.length > 0) {
              const userIds = Array.from(res.data.list, p => p.userId)
              const userList = getCacheListByKey(TYPE_NAMES.basic_data_User)
              for (const user of userList) {
                if (userIds.includes(user.userId) && user.email) {
                  if (!emails.includes(user.email)) {
                    emails.push(user.email)
                  }
                }
              }
            }
          })
        }
      }
      this.editDialog.form.ccAddress = emails.join(',')
    }
  }
}
</script>

<style scoped lang="scss">
.contact-form {
  &.section {
    padding: 10px 20px 20px 20px;
  }
  .el-select {
    width: 100%;
  }
  .no-pointer ::v-deep {
    .el-checkbox__input {
      cursor: default;
    }
  }
}
</style>
